<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="user.isSuperadmin || user.isManagerOrSupport")
            label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_school', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="schools",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                :loading="loadingSchools",
                @open="getSchools",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                v-model="form.school"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_schoolNotFound') }}
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_sort') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="sort",
                :show-labels="false",
                :placeholder="$i18n.t('fields.fields_sortPlaceholder')",
                :searchable="false",
                track-by="by",
                label="label",
                v-model="form.sort"
            )
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.t('fields.fields_search') }}
            cs-search-input.fields__input(
                :placeholder="$i18n.t('fields.list_adminPlaceholder')",
                v-model="form.fullName"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_status') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="statuses",
                :show-labels="false",
                :allow-empty="false",
                :custom-label="getStatusName",
                placeholder="",
                v-model="form.status",
                :searchable="false"
            )
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import SchoolApi from '../../../api/school';
    import searchFieldsMixin from '../../../utils/searchFieldsMixin'
    import {mapState} from 'vuex';
    import _ from 'lodash';
    import searchParamsStore from '../utils/searchParamsStore'
    import statusFieldMixin from '../utils/statusFieldMixin'

    export default {
        mixins: [searchFieldsMixin, searchParamsStore, statusFieldMixin],
        data() {
            return {
                sort: [
                    {label: this.$i18n.t('fields.list_sortFirstName'), by: 'first_name'},
                    {label: this.$i18n.t('fields.list_sortLastName'), by: 'last_name'}
                ],
                schools: [],
                form: {
                    sort: null,
                    school: null,
                    fullName: null,
                    status: 'active'
                }
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        sort: null,
                        school: null,
                        fullName: null,
                        status: 'active'
                    };
                }
            },
            'form.sort' () {
                this.updateList()
            },
            'form.school'() {
                this.updateList()
            },
            'form.fullName'() {
                this.updateList()
            },
            'form.status'() {
                this.updateList()
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
        },
        methods: {
            sendForm() {
                this.$emit(
                        'search',
                        Object.assign({}, this.form, {
                            sort: _.has(this.form, 'sort.by') ? this.form.sort.by : null
                        })
                );
            },
            resetResults() {
                this.$emit('search', this.form = {
                    sort: null,
                    school: null,
                    fullName: null,
                    status: 'active'
                });
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/sass/fields/fields.scss";
</style>
